import { useLayoutEffect } from "react";
import { publishTourView, retractTourView } from "./tourViews";

export const useTourView = (viewId: string, settled: boolean, anchors: readonly string[]): void => {
  const anchorsKey = anchors.slice().sort().join("|");

  useLayoutEffect(() => {
    publishTourView(viewId, {
      settled,
      anchors: anchorsKey === "" ? [] : anchorsKey.split("|"),
    });
  }, [viewId, settled, anchorsKey]);

  useLayoutEffect(() => {
    return () => {
      retractTourView(viewId);
    };
  }, [viewId]);
};
